module.exports = __webpack_public_path__ + "img/7.0_News_3_Noel-Hayman@2x.01e3afccbe8db65fbe6cd2f8133aee3e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/7.0_News_3_Noel-Hayman@2x.png
// module id = 798
// module chunks = 0